



























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { timeFormat } from '@/utils/other';


@Component({
  filters: {
    timeFormat,
  },
})
export default class ContentDetail extends Vue {
  @Prop({required: true}) private contentData!: IPayment.IContentData[];
}
